import {classNames, Fragment, observer, pluralize, React} from '@api'
import {Tooltip} from '@material-ui/core'
import {useAssortmentCardStore} from '@modules'
import {toJS} from 'mobx'
import * as css from './AssortmentCardPerspectives.css'
import {ICatalogFieldConfig, icons} from '@stores'
import {NumberBadge, PrimaryIconButton} from 'centric-ui-components'

export const AssortmentCardPerspectives = observer<{ className?: string }, HTMLDivElement>(function AssortmentCardPerspectives({className}, ref) {
  const {perspectives, reallyShowHeader, assortment: {hidePerspectiveButtons}} = useAssortmentCardStore()

  if (!reallyShowHeader) return null
  //console.log(toJS(perspectives, {recurseEverything: true}))
  return (<Fragment>
    <div className={classNames(className, css.root)} ref={ref}>
      <div className={css.perspectives}>
        <HeroCardsPerspectiveCountButton />
        {/* For the catalog items themselves */}
        {hidePerspectiveButtons !== true && <AssortmentPerspectiveCountButton/>}

        {hidePerspectiveButtons !== true && perspectives.map((f, i) => <AssortmentPerspectiveCountButton field={f} index={i} key={i}/>)}
      </div>
    </div>
  </Fragment>)
}, {forwardRef: true})

export const ToggleExpandButton = observer<{ tooltipPosition }>(function ToggleExpandButton({tooltipPosition}) {
  const {strings, expanded, root: {canExpandCards}, toggleExpanded} = useAssortmentCardStore()

  return (
    <PrimaryIconButton
      tooltip={!canExpandCards ? 'Column View must be Off' : expanded ? strings.collapse : strings.expand}
      tooltipPosition={tooltipPosition ?? 'bottom'}
      icon={expanded ? 'chevron-left' : 'chevron-right'}
      active={expanded}
      disabled={!canExpandCards}
      onClick={toggleExpanded}
    />)
})

export const AssortmentPerspectiveCountButton = observer<{ field?: ICatalogFieldConfig, index?: number }>(function AssortmentPerspectiveCountButton({field, index}) {
  const {catalog, onClickPerspective, strings, selectedPerspective, countForField} = useAssortmentCardStore()

  return (
    <Tooltip
      title={!field ? pluralize(catalog.catalogItemName) : catalog.labelForField(field, strings.emptyLabel, 'plural')}
    >
      <div className={css.perspective}
           data-index={index}
           data-field={field?.field ?? catalog.index}
           data-selected={selectedPerspective == field}
      >

        <NumberBadge className={css.count}
                     value={countForField(field)}
                     onClick={() => onClickPerspective(field)}/>

      </div>
    </Tooltip>)
})

export const HeroCardsPerspectiveCountButton = observer<{}>(function HeroCardsPerspectiveCountButton({}) {
  const {catalog, onClickPerspective, strings, selectedPerspective, componentStores: {heroCards}, root: {hero_foreignKeyFieldSkeleton}} = useAssortmentCardStore()

  return (
    <Tooltip
      title={pluralize(catalog.labelForField(hero_foreignKeyFieldSkeleton))}
    >
      <div className={css.perspective}
           data-selected={selectedPerspective == null}
           data-field='hero'
      >
        <NumberBadge className={css.count}
                     value={heroCards.cardData.length}
                     onClick={() => onClickPerspective(null)}/>

      </div>
    </Tooltip>)
})


// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/Assortments/AssortmentCard/Header/AssortmentCardPerspectives.tsx